import { CreateLtlePayload, TourOfferDeparture, TourOfferSummary } from '~/types/tours/tourOffer';

import { json_headers, request } from './common';
import { OkResponse, toursBasePath } from './toursApi';

export async function searchTourOffers(
  params: { search?: string; ltleOnly?: boolean },
  options?: { signal?: AbortSignal },
): Promise<Array<TourOfferSummary>> {
  const search = new URLSearchParams();
  if (params.search) {
    search.set('search', params.search);
  }
  if (params.ltleOnly) {
    search.set('ltleOnly', 'true');
  }
  const query = search.toString();

  const response: OkResponse<Array<TourOfferSummary>> = await request(
    `${toursBasePath()}/tour-offers${query ? `?${query}` : ''}`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}

export async function getTourOfferDepartures(
  tourOfferId: string,
  options?: { signal?: AbortSignal },
): Promise<Array<TourOfferDeparture>> {
  const response: OkResponse<Array<TourOfferDeparture>> = await request(
    `${toursBasePath()}/tour-offers/${tourOfferId}/departures`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}

/** Creates a native LTLE from a base tour offer; its service links back to the base. */
export async function createLtle(baseTourOfferId: string, payload: CreateLtlePayload): Promise<TourOfferSummary> {
  const response: OkResponse<TourOfferSummary> = await request(
    `${toursBasePath()}/tour-offers/${baseTourOfferId}/ltles`,
    {
      method: 'POST',
      headers: json_headers,
      body: JSON.stringify(payload),
    },
  );

  return response.result;
}
